import React from 'react'
import styled from 'styled-components'
import PokeBall from './PokeBall'

const StyledGameOver = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    grid-area: 1 / 1 / 2 / 5;
`

const PokeballContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 1rem;
`

const GameOver = (): JSX.Element => {
  return (
        <StyledGameOver>
            <h1>Game Over</h1>
            <h3>Thanks for playing!</h3>
            <PokeballContainer>
                {
                Array.from(Array(6)).map((_, index) => <PokeBall key={index} color="gray" />)
                }
            </PokeballContainer>
            <h6>Refresh to play again</h6>
        </StyledGameOver>
  )
}

export default GameOver
